import React, { useContext, useState } from 'react';

export enum LayoutBackgroundImage {
  HAND_WITH_APP = 'HAND_WITH_APP',
  MAN_WITH_APP = 'MAN_WITH_APP',
  SUCCSESS = 'SUCCSESS',
}

interface ContextType {
  email?: string;
  agreed: boolean;
  showToCWarning: boolean;
  agreedDisabled: boolean;
  phone?: string;
  fullName?: string;
  layoutBackgroundImage: LayoutBackgroundImage;
  setEmail: (email: string) => void;
  setPhone: (phone: string) => void;
  setFullName: (fullName: string) => void;
  setAgreed: (agreed: boolean) => void;
  setShowToCWarning: (showToCWarning: boolean) => void;
  setAgreedDisabled: (agreedDisabled: boolean) => void;
}

export const Context = React.createContext<ContextType>({
  email: undefined,
  phone: undefined,
  agreed: false,
  showToCWarning: false,
  agreedDisabled: false,
  fullName: undefined,
  layoutBackgroundImage: LayoutBackgroundImage.HAND_WITH_APP,
  setEmail: () => {},
  setAgreed: () => {},
  setShowToCWarning: () => {},
  setAgreedDisabled: () => {},
  setPhone: () => {},
  setFullName: () => {},
});

export const useAppContext = () => {
  return useContext(Context);
};

interface State {
  email?: string;
  agreed: boolean;
  showToCWarning: boolean;
  agreedDisabled: boolean;
  phone?: string;
  fullName?: string;
}
interface Props {
  layoutBackgroundImage: LayoutBackgroundImage;
  children: JSX.Element;
}

export const ContextProvider = (props: Props) => {
  const { children, layoutBackgroundImage } = props;

  const setEmail = (email: string) => {
    setState((prevState) => {
      return { ...prevState, email };
    });
  };

  const setAgreed = (agreed: boolean) => {
    setState((prevState) => {
      return { ...prevState, agreed };
    });
  };

  const setShowToCWarning = (showToCWarning: boolean) => {
    setState((prevState) => {
      return { ...prevState, showToCWarning };
    });
  };

  const setAgreedDisabled = (agreedDisabled: boolean) => {
    setState((prevState) => {
      return { ...prevState, agreedDisabled };
    });
  };

  const setPhone = (phone: string) => {
    setState((prevState) => {
      return { ...prevState, phone };
    });
  };

  const setFullName = (fullName: string) => {
    setState((prevState) => {
      return { ...prevState, fullName };
    });
  };

  const [state, setState] = useState<State>({
    agreed: false,
    showToCWarning: false,
    agreedDisabled: false,
  });

  return (
    <Context.Provider
      value={{
        ...state,
        setEmail,
        setAgreed,
        setShowToCWarning,
        setAgreedDisabled,
        setPhone,
        setFullName,
        layoutBackgroundImage,
      }}
    >
      {children}
    </Context.Provider>
  );
};
